import utils from "../utils";
import Splide from "@splidejs/splide";

function init() {

	flexSlider();
	flexCarousel();
	productGalleryCarousel();
	
}

function flexSlider() {

	var flexSliders = document.querySelectorAll(".splide.flex-slider-full")

	if(flexSliders.length > 0){

		utils.forEach(flexSliders, function (index, elem) {

			var flexSlider = new Splide(elem, {
				perPage: 1,
				perMove: 1,
				autoplay: false,
				interval: 5000,
				rewind: true,
				pauseOnHover: true,
				pauseOnFocus: false,
				resetProgress: true,
				arrows: true,
				speed: 2000,
				pagination: false,
				arrowPath: "m16.02,19.97L.92,35.05c-1.16,1.07-1.24,2.87-.17,4.03,1.07,1.16,2.87,1.24,4.03.17.06-.06.12-.12.18-.18l17.1-17.09c1.07-1.08,1.11-2.81.08-3.93L4.97.84c-1.11-1.12-2.92-1.12-4.03,0-1.12,1.11-1.12,2.92,0,4.03l15.08,15.1Z",
				classes: {
					// Add classes for arrows.
					arrows: "smx-navigation",
					arrow: "smx-nav",
					prev: "prev carousel-prev",
					next: "next carousel-next",
					pagination: "smx-pagination",
					page: "smx-dot",
				},
			});

			flexSlider.mount();

		});
		
	}

}

function flexCarousel() {

	var flexCarousel = document.querySelectorAll(".flex-carousel .splide.carousel")

	if(flexCarousel.length > 0){

		utils.forEach(flexCarousel, function (index, elem) {

			var flexCarousel = new Splide(elem, {
				type: 'slide',
				gap: '2rem',
				padding: { left: '0', right: '10rem' },
				perPage: 6,
				perMove: 6,
				snap: true,
				trimSpace: true,
				autoplay: false,
				rewind: true,
				pauseOnHover: true,
				pauseOnFocus: false,
				resetProgress: true,
				arrows: false,
				speed: 2000,
				pagination: true,
				classes: {
					// Add classes for arrows.
					arrows: "smx-navigation",
					arrow: "smx-nav",
					prev: "prev carousel-prev",
					next: "next carousel-next",
					pagination: "smx-pagination",
					page: "smx-dot",
				},
				breakpoints: {
					1200: {
						perPage: 5,
						perMove: 5,
						padding: { left: '0', right: '9rem' },
					},
					950: {
						perPage: 4,
						perMove: 4,
						padding: { left: '0', right: '8rem' },
					},
					768: {
						perPage: 3,
						perMove: 3,
						padding: { left: '0', right: '7rem' },
					},
					500: {
						perPage: 2,
						perMove: 2,
						padding: { left: '1rem', right: '6rem' },
					},
				},
			});

			flexCarousel.mount();

		});
		
	}

}

function productGalleryCarousel() {

	var productGalleryCarousel = document.getElementById("product-gallery-carousel");

	if(productGalleryCarousel){

		window.productGallery = new Splide(productGalleryCarousel, {
			perPage: 1,
			autoplay: false,
			pauseOnHover: false,
			speed: 500,
			omitEnd: true,
			updateOnMove: true,
			pagination: true,
			arrows: false,
            arrowPath: "M40,20C40,8.97,31.03,0,20,0S0,8.97,0,20s8.97,20,20,20,20-8.97,20-20Zm-37.67,0C2.33,10.25,10.25,2.33,20,2.33s17.67,7.93,17.67,17.67-7.93,17.67-17.67,17.67S2.33,29.75,2.33,20ZM30.93,20.75h0c.4-.4.4-1.09,0-1.49l-8.63-8.63c-.41-.41-1.08-.41-1.49,0-.2.2-.31.46-.31.74h0c0,.28.11.55.31.74l6.83,6.84H9.15c-.58,0-1.05.47-1.05,1.05s.47,1.05,1.05,1.05h18.5l-6.83,6.84c-.4.4-.4,1.09,0,1.49.2.2.46.31.74.31s.55-.11.74-.31l8.63-8.63Z",
			classes: {
				// Add classes for arrows.
				arrows: "smx-navigation",
				arrow: "smx-nav",
				prev: "prev carousel-prev",
				next: "next carousel-next",
				pagination: "smx-pagination",
				page: "smx-dot",
			},
		});
		
		// Verifico che serva il carosello essendoci almeno due immagini da visualizzare
		if(!productGalleryCarousel.classList.contains('not-mount')){
	
			// Monto il carosello principale
			window.productGallery.mount();
	
		}

	}

}

export default { init, productGalleryCarousel };